export default {"src":"/_next/static/media/left-icon.a3b72453.svg","height":36,"width":21};